import { Col, Container, Row } from "react-bootstrap"
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import ExportBox from "../components/ExportBox/ExportBox"
import DashboardCards from "../components/DashboardCards/DashboardCards"
// import axios from "axios"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import WeeklyCurve from "../components/WeeklyCurve/WeeklyCurve"
import TodayCurve from "../components/TodayCurve/TodayCurve"

function StudentDashboard() {
    const userinfo = useSelector((state) => state);
    const [item, setItem] = useState({})
    const [todayItems, setTodayItems] = useState([])
    const [weeklyItems, setWeeklyItems] = useState([])
    const { currentLocal } = useSelector((state) => state.currentLocal);

    useEffect(() => {
        // const getAllApis = async () => {


        //     await axios
        //         .get(`https://taarteb.com/api/dashboard`, {
        //             headers: {
        //                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        //             }
        //         })
        //         .then(async (res) => {
        //             setItem(res.data.data);


        //         })
        //         .catch((error) => {


        //         });



        //     await axios
        //         .get(`https://taarteb.com/api/todays-attendance-statistics`, {
        //             headers: {
        //                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        //             }
        //         })
        //         .then(async (res) => {
        //             setTodayItems(res.data.data)
        //         })
        //         .catch((error) => {

                    



        //         });
        //     await axios
        //         .get(`https://taarteb.com/api/weekly-attendance-report`, {
        //             headers: {
        //                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        //             }
        //         })
        //         .then(async (res) => {
        //             setWeeklyItems(res.data.data)


        //         })
        //         .catch((error) => {

                    



        //         });

        // }
        // getAllApis()

    }, [])
    const items = [
        //     { name:currentLocal.home.TotalTeachers, num: item && item.teachers ,path:"/dashboard/Teachers" },
        // { name: currentLocal.home.TotalClasses, num: item && item.classes,path:"/dashboard/Classes"  },
        // { name:currentLocal.home.TotalStudents,num: item && item.students,path:"/dashboard/Students"  },
        { name:currentLocal.home.Administrators,num: item && item.students,path:"/dashboard/Students"  },
        { name:currentLocal.home.Sales,num: item && item.students,path:"/dashboard/Students"  },
        { name:currentLocal.home.Purchases,num: item && item.students,path:"/dashboard/Students"  },
        { name:currentLocal.home.Maintenance,num: item && item.students,path:"/dashboard/Students"  },
        { name:currentLocal.home.Salaries,num: item && item.students,path:"/dashboard/Students"  },

    ]

    return (
        <div className="px-0 my-3 w-100 dashboard_content">
            <Container>
                <div className="d-flex flex-column w-100">
                    <AuthNavbar />
                    <div className="mt-5 mx-3">
                        <HomeTitle title={currentLocal.home.ManageYourSchoolsEfficiently} />


<ExportBox title={currentLocal.home.QuickSummary}
                                        paragrapg={currentLocal.home.Summary}
                                        exportState={false}
                                        btnState={false}

                                    />
<p className="w-100 text-start fw-bold"> {currentLocal.home.Totalsales}:150</p>
                        <DashboardCards
                            items={items}
                        />
                        <Row>
                            <Col md={6}>
                                <WeeklyCurve
                                    weeklyItems={weeklyItems}

                                />
                            </Col>
                            
                            <Col md={4}>
                                <TodayCurve
                                    todayItems={todayItems}
                                />
                            </Col>
                        </Row>
                    </div>


                </div>
            </Container>
        </div>
    )
}

export default StudentDashboard